
<template>
<!-- 封装的空内容组件 -->
<div :class="['empty_page', type ? type : '']">
  <div class="cereal">
    <img src="./../../../../../assets/images/feedRecord/cereal.png" alt="">
  </div>
  <slot v-if="$slots.default"></slot>
</div>
</template>

<script>

  export default {
    name: 'EmptyPage',
    data() {
      return {
      }
    },
    props: {
      type: {
        type: String,
        default: 'def'
      }
    }
  }
</script>

<style lang="less" scoped>
.empty_page {
  width: 100%;
  display: flex;
  padding: 0 109px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  &.def {}
  &.inventory_null {
    // height: 225px;
    padding: 40px 83px;
    box-sizing: border-box;
    .cereal {
      width: 184px;
      height: 122px;
      margin-bottom: 6px;
      >img {
        max-width: 100%;
      }
    }
  }
  &.record_null {
    // height: 185px;
    padding: 40px 83px;
    box-sizing: border-box;
  }
}
</style>